import { InputTitle } from 'components/input/InputTitle';
import { StatusTag } from 'components/tag/StatusTag';
import { AvatarUpload, Row, Spacing, TextInput, Typography, neutral, red } from 'enable-ui';

import { Footer } from 'modules/dashboard/components/Footer';
import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';
import { CustomAvatar } from 'modules/learners/styles/avatar';
import { TrainerPasswordForm } from 'modules/trainers/component/TrainerPasswordForm';
import { AvatarContainer, Container } from 'modules/trainers/styles/form';

import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';

import { MAX_FILE_SIZE } from 'constants/avatar';

import { AdminForm } from '../components/AdminForm';
import { useAdminFormController } from '../core/controller/admin-form';

export const AddAdminPage = () => {
  const {
    logoRef,
    onErrorAvatar,
    onChangeAvatar,
    logoURL,
    isErrorAvatar,
    logo,
    onDeleteLogo,
    onChangeGender,
    email,
    emailStatus,
    gender,
    disabled,
    goBack,
    handleChange,
    handleChangePhone,
    handleSubmit,
    phone,
    password,
    firstName,
    lastName,
    adminUserId,
    disabledButton,
    onCancel,
    isAddUser,
    adminDetail,
  } = useAdminFormController();

  return (
    <Container direction="column" style={{ maxWidth: 800 }}>
      <Spacing spacing="3xl" type="margin" placement="bottom">
        <HeaderDetailPage
          title={isAddUser ? 'Add admin user' : 'Admin details'}
          goBack={goBack}
          style={{ marginBottom: 0 }}
        />
      </Spacing>
      <Row direction="row">
        <Spacing spacing="3xl" type="margin" placement="right">
          <CustomAvatar>
            <AvatarUpload
              id="logo-trainer"
              size="lg"
              ref={logoRef}
              accept=".png,.jpeg,.svg,.webp"
              maxFileSize={MAX_FILE_SIZE}
              onError={onErrorAvatar}
              onChangeFile={onChangeAvatar}
              url={logoURL.value}
              style={{ cursor: 'pointer' }}
            />
            <label htmlFor="logo-trainer">
              <AvatarContainer>
                <AvatarIcon />
              </AvatarContainer>
            </label>
          </CustomAvatar>

          {isErrorAvatar && (
            <Typography
              weight={600}
              style={{
                marginTop: 4,
              }}
              color={red['red-5']}
              variant="body-3"
            >{`Max file size is 10Mb`}</Typography>
          )}
          {logo && (
            <Typography
              style={{
                whiteSpace: 'nowrap',
                color: '#FF4D4F',
                fontSize: '16px',
                cursor: 'pointer',
                textAlign: 'center',
                marginTop: 8,
              }}
              onClick={onDeleteLogo}
            >
              Remove
            </Typography>
          )}
        </Spacing>
        <Row direction="column">
          <Row
            direction="column"
            style={{
              paddingBottom: 48,
              borderBottom: `1px solid ${neutral['neutral-5']}`,
            }}
          >
            <Spacing spacing="md" type="margin" placement="bottom">
              <Typography variant="h4" weight={600}>
                General
              </Typography>
            </Spacing>
            {isAddUser ? (
              <>
                <InputTitle title="Email" required />
                <TextInput
                  name="email"
                  containerStyle={{ maxWidth: 'auto' }}
                  value={email}
                  onChange={handleChange}
                  helperText={emailStatus.helperText}
                  color={emailStatus.color}
                />
              </>
            ) : (
              <Row>
                <Row
                  direction="column"
                  style={{
                    width: 'fit-content',
                    marginRight: 100,
                  }}
                >
                  <InputTitle title="Status" />
                  <StatusTag isActive={adminDetail?.isActive} />
                </Row>
                <Row direction="column">
                  <InputTitle title="Email" />
                  <Row
                    align="center"
                    style={{
                      height: 32,
                    }}
                  >
                    <Typography variant="body-1">{adminDetail?.email || ''}</Typography>
                  </Row>
                </Row>
              </Row>
            )}
          </Row>
          <AdminForm
            gender={gender}
            phone={phone}
            handleChangePhone={handleChangePhone}
            handleChange={handleChange}
            onChangeGender={onChangeGender}
            firstName={firstName}
            lastName={lastName}
          />
          {!isAddUser && (
            <TrainerPasswordForm password={password || ''} handleChange={handleChange} />
          )}

          <Footer
            onCancel={onCancel}
            onSubmit={handleSubmit}
            disabled={adminUserId ? disabledButton : disabled}
            titleSubmit={adminUserId ? 'Save' : 'Add'}
            titleCancel={adminUserId && 'Cancel changes'}
            disabledCancel={adminUserId ? disabledButton : false}
          />
        </Row>
      </Row>
    </Container>
  );
};
